import React, { useEffect } from 'react';
import loadable from '@loadable/component';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import Loading from 'Components/Loading';
import ApplicationLayout from 'Components/ApplicationLayout';
import pMinDelay from 'p-min-delay';
import AsyncNotFound from 'Pages/NotFound';
import { getStaticPage } from 'Store/actions';

const StaticPage = loadable(() => pMinDelay(import('./StaticPage'), 300), {
  fallback: <Loading />
});

const getContractHtml = content => {
  if (!content || typeof content !== 'string') {
    return '';
  }

  let html = content;
  if (html.indexOf('&lt;') !== -1) {
    html = html.replace(/<\/?p>/gi, '');
    html = html
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&quot;/g, '"')
      .replace(/&#39;/g, "'")
      .replace(/&amp;/g, '&');
  }

  return html
    .replace(/<script\b[^<]*(?:(?!<\/script>)<[^<]*)*<\/script>/gi, '')
    .replace(/<iframe\b[^<]*(?:(?!<\/iframe>)<[^<]*)*<\/iframe>/gi, '')
    .replace(/\son\w+\s*=\s*("[^"]*"|'[^']*'|[^\s>]+)/gi, '');
};

const getPageContent = data => {
  const source = data && data.body ? data.body : data;
  const title = (source && (source.title || source.name)) || '';
  const html = getContractHtml(source && source.content);

  return {
    notFound: !title && !html,
    title,
    html
  };
};

export const loadData = ({ params } = {}) => (
  params?.slug ? [getStaticPage(params.slug)] : []
);

const AsyncStaticPage = props => {
  const dispatch = useDispatch();
  const slug = props.match?.params?.slug;
  const staticPage = useSelector(state => state.staticPage);
  const content = getPageContent(staticPage.data);
  const deviceType = props.userAgent.device?.type;

  useEffect(() => {
    dispatch(getStaticPage(slug));
  }, [dispatch, slug]);

  if (!staticPage.hasLoaded) {
    return <Loading />;
  }

  if (staticPage.notFound || content.notFound) {
    return <AsyncNotFound { ...props } />;
  }

  const pageConfig = {
    headerType: deviceType === 'desktop' ? 'full' : 'mobile-none',
    footerType: 'none',
    helmet: {
      bodyAttributes: {
        class: `${deviceType} hide-betslip hide-sticky-navigation`
      },
      title: content.title ? `${content.title} | Bilyoner` : 'Bilyoner'
    }
  };

  return (
    <ApplicationLayout { ...pageConfig } { ...props }>
      <StaticPage title={ content.title } html={ content.html } />
    </ApplicationLayout>
  );
};

AsyncStaticPage.propTypes = {
  userAgent: PropTypes.object,
  match: PropTypes.object
};

export default AsyncStaticPage;
